export const networkProviderIds = {
  connectedLife: 1,
  ttn: 2,
  helium: 3,
  mqttBojki: 4,
} as const
